import { topicsData } from '@/mocks/home';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热议话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            当前最火爆的吃瓜话题，点击查看完整爆料内容
          </p>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
          {topicsData.map((topic, i) => {
            const colors = [
              'bg-primary-100 text-primary-700 border-primary-200 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 border-accent-200 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 border-secondary-200 hover:bg-secondary-200',
              'bg-primary-50 text-primary-600 border-primary-100 hover:bg-primary-100',
              'bg-accent-50 text-accent-600 border-accent-100 hover:bg-accent-100',
              'bg-secondary-50 text-secondary-600 border-secondary-100 hover:bg-secondary-100',
              'bg-primary-100 text-primary-700 border-primary-200 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 border-accent-200 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 border-secondary-200 hover:bg-secondary-200',
            ];
            const colorIdx = i % colors.length;

            return (
              <a
                key={topic.id}
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#updates');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${colors[colorIdx]}`}
              >
                <i className={`${topic.icon} text-sm`}></i>
                <span>{topic.name}</span>
                <span className="text-xs opacity-70">{topic.heat}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}